import React from 'react'

function SocialLink({ title, name, href, openInSameTab }) {
  const socialLinkProps = {
    href,
    className: `share-component__btn share-component__btn--${name}`,
    title: title,
    rel: 'noopener noreferrer',
  }

  if (!openInSameTab) {
    socialLinkProps.target = '_blank'
  }

  return <a {...socialLinkProps} ta />
}

function SocialButton({ title, name, onClick }) {
  const socialbuttonProps = {
    onClick,
    className: `share-component__btn share-component__btn--${name}`,
    title: title,
    type: 'button',
  }
  return <button {...socialbuttonProps} />
}

export function SocialButtonOrLink(props) {
  return props.href ? SocialLink(props) : SocialButton(props)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/social_buttons/components/SocialButton.view.js